// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AffordabilitySimulatorRouteImport } from './routes/affordability-simulator'
import { Route as AgentAuthRouteImport } from './routes/agent-auth'
import { Route as AgentDashboardRouteImport } from './routes/agent-dashboard'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CheckMyScoreRouteImport } from './routes/check-my-score'
import { Route as ChecklistRouteImport } from './routes/checklist'
import { Route as CompanyDashboardRouteImport } from './routes/company-dashboard'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ContestsRouteImport } from './routes/contests'
import { Route as CreditReadinessRouteImport } from './routes/credit-readiness'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DownPaymentPlannerRouteImport } from './routes/down-payment-planner'
import { Route as EmployerDashboardRouteImport } from './routes/employer-dashboard'
import { Route as EmployerOnboardingRouteImport } from './routes/employer-onboarding'
import { Route as EmployerReportRouteImport } from './routes/employer-report'
import { Route as ExpertAuthRouteImport } from './routes/expert-auth'
import { Route as ExpertDashboardRouteImport } from './routes/expert-dashboard'
import { Route as ExpertQaRouteImport } from './routes/expert-qa'
import { Route as FocusGroupRouteImport } from './routes/focus-group'
import { Route as ForOrganizationsRouteImport } from './routes/for-organizations'
import { Route as FoundingMembersRouteImport } from './routes/founding-members'
import { Route as FreeCreditScoreRouteImport } from './routes/free-credit-score'
import { Route as GoalsRouteImport } from './routes/goals'
import { Route as GrantFinderRouteImport } from './routes/grant-finder'
import { Route as HeroBenefitsEnrollRouteImport } from './routes/hero-benefits-enroll'
import { Route as HeroHomeSignupRouteImport } from './routes/hero-home-signup'
import { Route as HeroRewardsRouteImport } from './routes/hero-rewards'
import { Route as HomeValueRouteImport } from './routes/home-value'
import { Route as HomebuyerChecklistRouteImport } from './routes/homebuyer-checklist'
import { Route as HomebuyingSupportRouteImport } from './routes/homebuying-support'
import { Route as HomeownerCheckupRouteImport } from './routes/homeowner-checkup'
import { Route as HowWeMakeMoneyRouteImport } from './routes/how-we-make-money'
import { Route as InstallRouteImport } from './routes/install'
import { Route as LeaderboardRouteImport } from './routes/leaderboard'
import { Route as LenderMatchRouteImport } from './routes/lender-match'
import { Route as MortgageCalculatorsRouteImport } from './routes/mortgage-calculators'
import { Route as MortgageGlossaryRouteImport } from './routes/mortgage-glossary'
import { Route as MyPlanRouteImport } from './routes/my-plan'
import { Route as NeighborhoodExplorerRouteImport } from './routes/neighborhood-explorer'
import { Route as NeighborhoodWatchlistRouteImport } from './routes/neighborhood-watchlist'
import { Route as OffersRouteImport } from './routes/offers'
import { Route as OurPromiseRouteImport } from './routes/our-promise'
import { Route as PointsStoreRouteImport } from './routes/points-store'
import { Route as PrestigeRouteImport } from './routes/prestige'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PulseRouteImport } from './routes/pulse'
import { Route as ReadinessCheckRouteImport } from './routes/readiness-check'
import { Route as ReferYourEmployerRouteImport } from './routes/refer-your-employer'
import { Route as RefiOptimizerRouteImport } from './routes/refi-optimizer'
import { Route as RelocationCalculatorRouteImport } from './routes/relocation-calculator'
import { Route as RentVsBuyRouteImport } from './routes/rent-vs-buy'
import { Route as RequestAccessRouteImport } from './routes/request-access'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RewardsRouteImport } from './routes/rewards'
import { Route as ShareProgressRouteImport } from './routes/share-progress'
import { Route as SponsorDeckRouteImport } from './routes/sponsor-deck'
import { Route as SuccessStoriesRouteImport } from './routes/success-stories'
import { Route as TermsAndConditionsRouteImport } from './routes/terms-and-conditions'
import { Route as WellnessSurveyRouteImport } from './routes/wellness-survey'
import { Route as YourMatchRouteImport } from './routes/your-match'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAffiliatesRouteImport } from './routes/admin/affiliates'
import { Route as AdminAudiencekeyRouteImport } from './routes/admin/audiencekey'
import { Route as AdminContentAutomationsRouteImport } from './routes/admin/content-automations'
import { Route as AdminContentFlywheelRouteImport } from './routes/admin/content-flywheel'
import { Route as AdminEmailAuthRouteImport } from './routes/admin/email-auth'
import { Route as AdminEmployersRouteImport } from './routes/admin/employers'
import { Route as AdminFocusGroupRouteImport } from './routes/admin/focus-group'
import { Route as AdminFunnelRouteImport } from './routes/admin/funnel'
import { Route as AdminGeckocheckRouteImport } from './routes/admin/geckocheck'
import { Route as AdminGeckocheckMcpRouteImport } from './routes/admin/geckocheck-mcp'
import { Route as AdminGrantsRouteImport } from './routes/admin/grants'
import { Route as AdminLeadBriefRouteImport } from './routes/admin/lead-brief'
import { Route as AdminLinkBuilderRouteImport } from './routes/admin/link-builder'
import { Route as AdminMembersRouteImport } from './routes/admin/members'
import { Route as AdminOffersRouteImport } from './routes/admin/offers'
import { Route as AdminPeoPartnersRouteImport } from './routes/admin/peo-partners'
import { Route as AdminPulseRouteImport } from './routes/admin/pulse'
import { Route as AdminReportingRouteImport } from './routes/admin/reporting'
import { Route as AdminSmsRouteImport } from './routes/admin/sms'
import { Route as AdminWebinarsRouteImport } from './routes/admin/webinars'
import { Route as ApprovedLendersIndexRouteImport } from './routes/approved-lenders/index'
import { Route as ApprovedLendersStateRouteImport } from './routes/approved-lenders/$state'
import { Route as ArticlesIndexRouteImport } from './routes/articles/index'
import { Route as ArticlesSlugRouteImport } from './routes/articles/$slug'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as ClosingCostsIndexRouteImport } from './routes/closing-costs/index'
import { Route as ClosingCostsStateRouteImport } from './routes/closing-costs/$state'
import { Route as DecksYonkersRouteImport } from './routes/decks/yonkers'
import { Route as EmbedGeneratorRouteImport } from './routes/embed/generator'
import { Route as EmbedReadinessRouteImport } from './routes/embed/readiness'
import { Route as EmployersClaimRouteImport } from './routes/employers/claim'
import { Route as ExpertFollowupTokenRouteImport } from './routes/expert-followup/$token'
import { Route as ExpertsIndexRouteImport } from './routes/experts/index'
import { Route as ExpertsIdRouteImport } from './routes/experts/$id'
import { Route as FirstTimeBuyerIndexRouteImport } from './routes/first-time-buyer/index'
import { Route as FirstTimeBuyerStateRouteImport } from './routes/first-time-buyer/$state'
import { Route as GrantsIndexRouteImport } from './routes/grants/index'
import { Route as GrantsStateRouteImport } from './routes/grants/$state'
import { Route as GuidesIndexRouteImport } from './routes/guides/index'
import { Route as GuidesSlugRouteImport } from './routes/guides/$slug'
import { Route as HomieIndexRouteImport } from './routes/homie.index'
import { Route as HomieChatRouteImport } from './routes/homie.chat'
import { Route as LearnIndexRouteImport } from './routes/learn/index'
import { Route as LearnRubenRouteImport } from './routes/learn/ruben'
import { Route as LifemartIndexRouteImport } from './routes/lifemart/index'
import { Route as LifemartAccessRouteImport } from './routes/lifemart/access'
import { Route as LifemartFreeCreditScoreRouteImport } from './routes/lifemart/free-credit-score'
import { Route as LifemartHookPreviewRouteImport } from './routes/lifemart/hook-preview'
import { Route as LifemartPreviewRouteImport } from './routes/lifemart/preview'
import { Route as LifemartStackRouteImport } from './routes/lifemart/stack'
import { Route as LifemartStackInviteRouteImport } from './routes/lifemart/stack-invite'
import { Route as LifemartStackOfferRouteImport } from './routes/lifemart/stack-offer'
import { Route as LifemartSurveyRouteImport } from './routes/lifemart/survey'
import { Route as LpAgentRouteImport } from './routes/lp/agent'
import { Route as LpOrganizationsRouteImport } from './routes/lp/organizations'
import { Route as LpRubenRouteImport } from './routes/lp/ruben'
import { Route as MemberFollowupTokenRouteImport } from './routes/member-followup/$token'
import { Route as MortgageRatesIndexRouteImport } from './routes/mortgage-rates/index'
import { Route as MortgageRatesStateRouteImport } from './routes/mortgage-rates/$state'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as OnboardingCreditMatchRouteImport } from './routes/onboarding/credit-match'
import { Route as PSlugRouteImport } from './routes/p/$slug'
import { Route as PartnerSlugRouteImport } from './routes/partner/$slug'
import { Route as PartnersIndexRouteImport } from './routes/partners/index'
import { Route as PartnersChenoaFundRouteImport } from './routes/partners/chenoa-fund'
import { Route as PartnersNacaRouteImport } from './routes/partners/naca'
import { Route as PartnersNeighborworksRouteImport } from './routes/partners/neighborworks'
import { Route as PartnersOperationHopeRouteImport } from './routes/partners/operation-hope'
import { Route as PartnersUnidosUsRouteImport } from './routes/partners/unidos-us'
import { Route as PartnersUrbanLeagueRouteImport } from './routes/partners/urban-league'
import { Route as PreviewHomieLifemartRouteImport } from './routes/preview/homie-lifemart'
import { Route as PreviewLarkStyleRouteImport } from './routes/preview/lark-style'
import { Route as ProfileCompleteRouteImport } from './routes/profile/complete'
import { Route as StackCheckTokenRouteImport } from './routes/stack-check/$token'
import { Route as StackIndexRouteImport } from './routes/stack/index'
import { Route as StackGuideRouteImport } from './routes/stack/guide'
import { Route as ToolsIndexRouteImport } from './routes/tools/index'
import { Route as ToolsAssistanceFundingAvailabilityRouteImport } from './routes/tools/assistance-funding-availability'
import { Route as ToolsAvoidForeclosureRouteImport } from './routes/tools/avoid-foreclosure'
import { Route as ToolsBuyBeforeSellingRouteImport } from './routes/tools/buy-before-selling'
import { Route as ToolsCashToCloseRouteImport } from './routes/tools/cash-to-close'
import { Route as ToolsClosingDisclosureReviewRouteImport } from './routes/tools/closing-disclosure-review'
import { Route as ToolsCombiningAssistanceProgramsRouteImport } from './routes/tools/combining-assistance-programs'
import { Route as ToolsCompareLenderQuotesRouteImport } from './routes/tools/compare-lender-quotes'
import { Route as ToolsCompareLoanEstimatesRouteImport } from './routes/tools/compare-loan-estimates'
import { Route as ToolsDownPaymentAssistanceEstimateRouteImport } from './routes/tools/down-payment-assistance-estimate'
import { Route as ToolsDpaHiddenStringsRouteImport } from './routes/tools/dpa-hidden-strings'
import { Route as ToolsDpaSellOrRefinanceRouteImport } from './routes/tools/dpa-sell-or-refinance'
import { Route as ToolsFindHousingCounselorRouteImport } from './routes/tools/find-housing-counselor'
import { Route as ToolsFirstResponderHomeBuyingRouteImport } from './routes/tools/first-responder-home-buying'
import { Route as ToolsFreeHomebuyingReadinessToolsRouteImport } from './routes/tools/free-homebuying-readiness-tools'
import { Route as ToolsHighIncomeDownPaymentHelpRouteImport } from './routes/tools/high-income-down-payment-help'
import { Route as ToolsHomeBuyingTimelineRouteImport } from './routes/tools/home-buying-timeline'
import { Route as ToolsHomebuyerReadinessScoreRouteImport } from './routes/tools/homebuyer-readiness-score'
import { Route as ToolsInheritedHomeMortgageRouteImport } from './routes/tools/inherited-home-mortgage'
import { Route as ToolsLoanOfficerQuestionsRouteImport } from './routes/tools/loan-officer-questions'
import { Route as ToolsLowIncomeFirstTimeBuyerGrantsRouteImport } from './routes/tools/low-income-first-time-buyer-grants'
import { Route as ToolsMortgagePreapprovalMeetingRouteImport } from './routes/tools/mortgage-preapproval-meeting'
import { Route as ToolsMortgageReadyChecklistRouteImport } from './routes/tools/mortgage-ready-checklist'
import { Route as ToolsNonprofitMortgageHelpRouteImport } from './routes/tools/nonprofit-mortgage-help'
import { Route as ToolsRaiseCreditScoreBeforeMortgageRouteImport } from './routes/tools/raise-credit-score-before-mortgage'
import { Route as ToolsRealAffordabilityRouteImport } from './routes/tools/real-affordability'
import { Route as ToolsRelocationTimingRouteImport } from './routes/tools/relocation-timing'
import { Route as ToolsRepaymentTriggersRouteImport } from './routes/tools/repayment-triggers'
import { Route as ToolsRightTimeToBuyRouteImport } from './routes/tools/right-time-to-buy'
import { Route as ToolsStudentLoanMortgageGuideRouteImport } from './routes/tools/student-loan-mortgage-guide'
import { Route as ToolsWhatIsMyHomeWorthRouteImport } from './routes/tools/what-is-my-home-worth'
import { Route as WebinarsIndexRouteImport } from './routes/webinars/index'
import { Route as WebinarsIdRouteImport } from './routes/webinars/$id'
import { Route as AdminBlogIndexRouteImport } from './routes/admin/blog/index'
import { Route as AdminBlogIdRouteImport } from './routes/admin/blog/$id'
import { Route as AdminBlogNewRouteImport } from './routes/admin/blog/new'
import { Route as ClosingCostsCityCityRouteImport } from './routes/closing-costs/city/$city'
import { Route as FirstTimeBuyerCityCityRouteImport } from './routes/first-time-buyer/city/$city'
import { Route as GrantsCityCityRouteImport } from './routes/grants/city/$city'
import { Route as LearnSlugStepIndexRouteImport } from './routes/learn/$slug.$stepIndex'
import { Route as LpHeroStackIndexRouteImport } from './routes/lp/hero-stack/index'
import { Route as LpHeroStackThankYouRouteImport } from './routes/lp/hero-stack/thank-you'
import { Route as LpRubenHeroIndexRouteImport } from './routes/lp/ruben-hero/index'
import { Route as LpRubenHeroResultsRouteImport } from './routes/lp/ruben-hero/results'
import { Route as MortgageRatesCityCityRouteImport } from './routes/mortgage-rates/city/$city'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AffordabilitySimulatorRoute = AffordabilitySimulatorRouteImport.update({
            id: '/affordability-simulator',path: '/affordability-simulator',getParentRoute: () => rootRouteImport
          })
const AgentAuthRoute = AgentAuthRouteImport.update({
            id: '/agent-auth',path: '/agent-auth',getParentRoute: () => rootRouteImport
          })
const AgentDashboardRoute = AgentDashboardRouteImport.update({
            id: '/agent-dashboard',path: '/agent-dashboard',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const CheckMyScoreRoute = CheckMyScoreRouteImport.update({
            id: '/check-my-score',path: '/check-my-score',getParentRoute: () => rootRouteImport
          })
const ChecklistRoute = ChecklistRouteImport.update({
            id: '/checklist',path: '/checklist',getParentRoute: () => rootRouteImport
          })
const CompanyDashboardRoute = CompanyDashboardRouteImport.update({
            id: '/company-dashboard',path: '/company-dashboard',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ContestsRoute = ContestsRouteImport.update({
            id: '/contests',path: '/contests',getParentRoute: () => rootRouteImport
          })
const CreditReadinessRoute = CreditReadinessRouteImport.update({
            id: '/credit-readiness',path: '/credit-readiness',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const DownPaymentPlannerRoute = DownPaymentPlannerRouteImport.update({
            id: '/down-payment-planner',path: '/down-payment-planner',getParentRoute: () => rootRouteImport
          })
const EmployerDashboardRoute = EmployerDashboardRouteImport.update({
            id: '/employer-dashboard',path: '/employer-dashboard',getParentRoute: () => rootRouteImport
          })
const EmployerOnboardingRoute = EmployerOnboardingRouteImport.update({
            id: '/employer-onboarding',path: '/employer-onboarding',getParentRoute: () => rootRouteImport
          })
const EmployerReportRoute = EmployerReportRouteImport.update({
            id: '/employer-report',path: '/employer-report',getParentRoute: () => rootRouteImport
          })
const ExpertAuthRoute = ExpertAuthRouteImport.update({
            id: '/expert-auth',path: '/expert-auth',getParentRoute: () => rootRouteImport
          })
const ExpertDashboardRoute = ExpertDashboardRouteImport.update({
            id: '/expert-dashboard',path: '/expert-dashboard',getParentRoute: () => rootRouteImport
          })
const ExpertQaRoute = ExpertQaRouteImport.update({
            id: '/expert-qa',path: '/expert-qa',getParentRoute: () => rootRouteImport
          })
const FocusGroupRoute = FocusGroupRouteImport.update({
            id: '/focus-group',path: '/focus-group',getParentRoute: () => rootRouteImport
          })
const ForOrganizationsRoute = ForOrganizationsRouteImport.update({
            id: '/for-organizations',path: '/for-organizations',getParentRoute: () => rootRouteImport
          })
const FoundingMembersRoute = FoundingMembersRouteImport.update({
            id: '/founding-members',path: '/founding-members',getParentRoute: () => rootRouteImport
          })
const FreeCreditScoreRoute = FreeCreditScoreRouteImport.update({
            id: '/free-credit-score',path: '/free-credit-score',getParentRoute: () => rootRouteImport
          })
const GoalsRoute = GoalsRouteImport.update({
            id: '/goals',path: '/goals',getParentRoute: () => rootRouteImport
          })
const GrantFinderRoute = GrantFinderRouteImport.update({
            id: '/grant-finder',path: '/grant-finder',getParentRoute: () => rootRouteImport
          })
const HeroBenefitsEnrollRoute = HeroBenefitsEnrollRouteImport.update({
            id: '/hero-benefits-enroll',path: '/hero-benefits-enroll',getParentRoute: () => rootRouteImport
          })
const HeroHomeSignupRoute = HeroHomeSignupRouteImport.update({
            id: '/hero-home-signup',path: '/hero-home-signup',getParentRoute: () => rootRouteImport
          })
const HeroRewardsRoute = HeroRewardsRouteImport.update({
            id: '/hero-rewards',path: '/hero-rewards',getParentRoute: () => rootRouteImport
          })
const HomeValueRoute = HomeValueRouteImport.update({
            id: '/home-value',path: '/home-value',getParentRoute: () => rootRouteImport
          })
const HomebuyerChecklistRoute = HomebuyerChecklistRouteImport.update({
            id: '/homebuyer-checklist',path: '/homebuyer-checklist',getParentRoute: () => rootRouteImport
          })
const HomebuyingSupportRoute = HomebuyingSupportRouteImport.update({
            id: '/homebuying-support',path: '/homebuying-support',getParentRoute: () => rootRouteImport
          })
const HomeownerCheckupRoute = HomeownerCheckupRouteImport.update({
            id: '/homeowner-checkup',path: '/homeowner-checkup',getParentRoute: () => rootRouteImport
          })
const HowWeMakeMoneyRoute = HowWeMakeMoneyRouteImport.update({
            id: '/how-we-make-money',path: '/how-we-make-money',getParentRoute: () => rootRouteImport
          })
const InstallRoute = InstallRouteImport.update({
            id: '/install',path: '/install',getParentRoute: () => rootRouteImport
          })
const LeaderboardRoute = LeaderboardRouteImport.update({
            id: '/leaderboard',path: '/leaderboard',getParentRoute: () => rootRouteImport
          })
const LenderMatchRoute = LenderMatchRouteImport.update({
            id: '/lender-match',path: '/lender-match',getParentRoute: () => rootRouteImport
          })
const MortgageCalculatorsRoute = MortgageCalculatorsRouteImport.update({
            id: '/mortgage-calculators',path: '/mortgage-calculators',getParentRoute: () => rootRouteImport
          })
const MortgageGlossaryRoute = MortgageGlossaryRouteImport.update({
            id: '/mortgage-glossary',path: '/mortgage-glossary',getParentRoute: () => rootRouteImport
          })
const MyPlanRoute = MyPlanRouteImport.update({
            id: '/my-plan',path: '/my-plan',getParentRoute: () => rootRouteImport
          })
const NeighborhoodExplorerRoute = NeighborhoodExplorerRouteImport.update({
            id: '/neighborhood-explorer',path: '/neighborhood-explorer',getParentRoute: () => rootRouteImport
          })
const NeighborhoodWatchlistRoute = NeighborhoodWatchlistRouteImport.update({
            id: '/neighborhood-watchlist',path: '/neighborhood-watchlist',getParentRoute: () => rootRouteImport
          })
const OffersRoute = OffersRouteImport.update({
            id: '/offers',path: '/offers',getParentRoute: () => rootRouteImport
          })
const OurPromiseRoute = OurPromiseRouteImport.update({
            id: '/our-promise',path: '/our-promise',getParentRoute: () => rootRouteImport
          })
const PointsStoreRoute = PointsStoreRouteImport.update({
            id: '/points-store',path: '/points-store',getParentRoute: () => rootRouteImport
          })
const PrestigeRoute = PrestigeRouteImport.update({
            id: '/prestige',path: '/prestige',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PulseRoute = PulseRouteImport.update({
            id: '/pulse',path: '/pulse',getParentRoute: () => rootRouteImport
          })
const ReadinessCheckRoute = ReadinessCheckRouteImport.update({
            id: '/readiness-check',path: '/readiness-check',getParentRoute: () => rootRouteImport
          })
const ReferYourEmployerRoute = ReferYourEmployerRouteImport.update({
            id: '/refer-your-employer',path: '/refer-your-employer',getParentRoute: () => rootRouteImport
          })
const RefiOptimizerRoute = RefiOptimizerRouteImport.update({
            id: '/refi-optimizer',path: '/refi-optimizer',getParentRoute: () => rootRouteImport
          })
const RelocationCalculatorRoute = RelocationCalculatorRouteImport.update({
            id: '/relocation-calculator',path: '/relocation-calculator',getParentRoute: () => rootRouteImport
          })
const RentVsBuyRoute = RentVsBuyRouteImport.update({
            id: '/rent-vs-buy',path: '/rent-vs-buy',getParentRoute: () => rootRouteImport
          })
const RequestAccessRoute = RequestAccessRouteImport.update({
            id: '/request-access',path: '/request-access',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RewardsRoute = RewardsRouteImport.update({
            id: '/rewards',path: '/rewards',getParentRoute: () => rootRouteImport
          })
const ShareProgressRoute = ShareProgressRouteImport.update({
            id: '/share-progress',path: '/share-progress',getParentRoute: () => rootRouteImport
          })
const SponsorDeckRoute = SponsorDeckRouteImport.update({
            id: '/sponsor-deck',path: '/sponsor-deck',getParentRoute: () => rootRouteImport
          })
const SuccessStoriesRoute = SuccessStoriesRouteImport.update({
            id: '/success-stories',path: '/success-stories',getParentRoute: () => rootRouteImport
          })
const TermsAndConditionsRoute = TermsAndConditionsRouteImport.update({
            id: '/terms-and-conditions',path: '/terms-and-conditions',getParentRoute: () => rootRouteImport
          })
const WellnessSurveyRoute = WellnessSurveyRouteImport.update({
            id: '/wellness-survey',path: '/wellness-survey',getParentRoute: () => rootRouteImport
          })
const YourMatchRoute = YourMatchRouteImport.update({
            id: '/your-match',path: '/your-match',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminAffiliatesRoute = AdminAffiliatesRouteImport.update({
            id: '/admin/affiliates',path: '/admin/affiliates',getParentRoute: () => rootRouteImport
          })
const AdminAudiencekeyRoute = AdminAudiencekeyRouteImport.update({
            id: '/admin/audiencekey',path: '/admin/audiencekey',getParentRoute: () => rootRouteImport
          })
const AdminContentAutomationsRoute = AdminContentAutomationsRouteImport.update({
            id: '/admin/content-automations',path: '/admin/content-automations',getParentRoute: () => rootRouteImport
          })
const AdminContentFlywheelRoute = AdminContentFlywheelRouteImport.update({
            id: '/admin/content-flywheel',path: '/admin/content-flywheel',getParentRoute: () => rootRouteImport
          })
const AdminEmailAuthRoute = AdminEmailAuthRouteImport.update({
            id: '/admin/email-auth',path: '/admin/email-auth',getParentRoute: () => rootRouteImport
          })
const AdminEmployersRoute = AdminEmployersRouteImport.update({
            id: '/admin/employers',path: '/admin/employers',getParentRoute: () => rootRouteImport
          })
const AdminFocusGroupRoute = AdminFocusGroupRouteImport.update({
            id: '/admin/focus-group',path: '/admin/focus-group',getParentRoute: () => rootRouteImport
          })
const AdminFunnelRoute = AdminFunnelRouteImport.update({
            id: '/admin/funnel',path: '/admin/funnel',getParentRoute: () => rootRouteImport
          })
const AdminGeckocheckRoute = AdminGeckocheckRouteImport.update({
            id: '/admin/geckocheck',path: '/admin/geckocheck',getParentRoute: () => rootRouteImport
          })
const AdminGeckocheckMcpRoute = AdminGeckocheckMcpRouteImport.update({
            id: '/admin/geckocheck-mcp',path: '/admin/geckocheck-mcp',getParentRoute: () => rootRouteImport
          })
const AdminGrantsRoute = AdminGrantsRouteImport.update({
            id: '/admin/grants',path: '/admin/grants',getParentRoute: () => rootRouteImport
          })
const AdminLeadBriefRoute = AdminLeadBriefRouteImport.update({
            id: '/admin/lead-brief',path: '/admin/lead-brief',getParentRoute: () => rootRouteImport
          })
const AdminLinkBuilderRoute = AdminLinkBuilderRouteImport.update({
            id: '/admin/link-builder',path: '/admin/link-builder',getParentRoute: () => rootRouteImport
          })
const AdminMembersRoute = AdminMembersRouteImport.update({
            id: '/admin/members',path: '/admin/members',getParentRoute: () => rootRouteImport
          })
const AdminOffersRoute = AdminOffersRouteImport.update({
            id: '/admin/offers',path: '/admin/offers',getParentRoute: () => rootRouteImport
          })
const AdminPeoPartnersRoute = AdminPeoPartnersRouteImport.update({
            id: '/admin/peo-partners',path: '/admin/peo-partners',getParentRoute: () => rootRouteImport
          })
const AdminPulseRoute = AdminPulseRouteImport.update({
            id: '/admin/pulse',path: '/admin/pulse',getParentRoute: () => rootRouteImport
          })
const AdminReportingRoute = AdminReportingRouteImport.update({
            id: '/admin/reporting',path: '/admin/reporting',getParentRoute: () => rootRouteImport
          })
const AdminSmsRoute = AdminSmsRouteImport.update({
            id: '/admin/sms',path: '/admin/sms',getParentRoute: () => rootRouteImport
          })
const AdminWebinarsRoute = AdminWebinarsRouteImport.update({
            id: '/admin/webinars',path: '/admin/webinars',getParentRoute: () => rootRouteImport
          })
const ApprovedLendersIndexRoute = ApprovedLendersIndexRouteImport.update({
            id: '/approved-lenders/',path: '/approved-lenders/',getParentRoute: () => rootRouteImport
          })
const ApprovedLendersStateRoute = ApprovedLendersStateRouteImport.update({
            id: '/approved-lenders/$state',path: '/approved-lenders/$state',getParentRoute: () => rootRouteImport
          })
const ArticlesIndexRoute = ArticlesIndexRouteImport.update({
            id: '/articles/',path: '/articles/',getParentRoute: () => rootRouteImport
          })
const ArticlesSlugRoute = ArticlesSlugRouteImport.update({
            id: '/articles/$slug',path: '/articles/$slug',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ClosingCostsIndexRoute = ClosingCostsIndexRouteImport.update({
            id: '/closing-costs/',path: '/closing-costs/',getParentRoute: () => rootRouteImport
          })
const ClosingCostsStateRoute = ClosingCostsStateRouteImport.update({
            id: '/closing-costs/$state',path: '/closing-costs/$state',getParentRoute: () => rootRouteImport
          })
const DecksYonkersRoute = DecksYonkersRouteImport.update({
            id: '/decks/yonkers',path: '/decks/yonkers',getParentRoute: () => rootRouteImport
          })
const EmbedGeneratorRoute = EmbedGeneratorRouteImport.update({
            id: '/embed/generator',path: '/embed/generator',getParentRoute: () => rootRouteImport
          })
const EmbedReadinessRoute = EmbedReadinessRouteImport.update({
            id: '/embed/readiness',path: '/embed/readiness',getParentRoute: () => rootRouteImport
          })
const EmployersClaimRoute = EmployersClaimRouteImport.update({
            id: '/employers/claim',path: '/employers/claim',getParentRoute: () => rootRouteImport
          })
const ExpertFollowupTokenRoute = ExpertFollowupTokenRouteImport.update({
            id: '/expert-followup/$token',path: '/expert-followup/$token',getParentRoute: () => rootRouteImport
          })
const ExpertsIndexRoute = ExpertsIndexRouteImport.update({
            id: '/experts/',path: '/experts/',getParentRoute: () => rootRouteImport
          })
const ExpertsIdRoute = ExpertsIdRouteImport.update({
            id: '/experts/$id',path: '/experts/$id',getParentRoute: () => rootRouteImport
          })
const FirstTimeBuyerIndexRoute = FirstTimeBuyerIndexRouteImport.update({
            id: '/first-time-buyer/',path: '/first-time-buyer/',getParentRoute: () => rootRouteImport
          })
const FirstTimeBuyerStateRoute = FirstTimeBuyerStateRouteImport.update({
            id: '/first-time-buyer/$state',path: '/first-time-buyer/$state',getParentRoute: () => rootRouteImport
          })
const GrantsIndexRoute = GrantsIndexRouteImport.update({
            id: '/grants/',path: '/grants/',getParentRoute: () => rootRouteImport
          })
const GrantsStateRoute = GrantsStateRouteImport.update({
            id: '/grants/$state',path: '/grants/$state',getParentRoute: () => rootRouteImport
          })
const GuidesIndexRoute = GuidesIndexRouteImport.update({
            id: '/guides/',path: '/guides/',getParentRoute: () => rootRouteImport
          })
const GuidesSlugRoute = GuidesSlugRouteImport.update({
            id: '/guides/$slug',path: '/guides/$slug',getParentRoute: () => rootRouteImport
          })
const HomieIndexRoute = HomieIndexRouteImport.update({
            id: '/homie/',path: '/homie/',getParentRoute: () => rootRouteImport
          })
const HomieChatRoute = HomieChatRouteImport.update({
            id: '/homie/chat',path: '/homie/chat',getParentRoute: () => rootRouteImport
          })
const LearnIndexRoute = LearnIndexRouteImport.update({
            id: '/learn/',path: '/learn/',getParentRoute: () => rootRouteImport
          })
const LearnRubenRoute = LearnRubenRouteImport.update({
            id: '/learn/ruben',path: '/learn/ruben',getParentRoute: () => rootRouteImport
          })
const LifemartIndexRoute = LifemartIndexRouteImport.update({
            id: '/lifemart/',path: '/lifemart/',getParentRoute: () => rootRouteImport
          })
const LifemartAccessRoute = LifemartAccessRouteImport.update({
            id: '/lifemart/access',path: '/lifemart/access',getParentRoute: () => rootRouteImport
          })
const LifemartFreeCreditScoreRoute = LifemartFreeCreditScoreRouteImport.update({
            id: '/lifemart/free-credit-score',path: '/lifemart/free-credit-score',getParentRoute: () => rootRouteImport
          })
const LifemartHookPreviewRoute = LifemartHookPreviewRouteImport.update({
            id: '/lifemart/hook-preview',path: '/lifemart/hook-preview',getParentRoute: () => rootRouteImport
          })
const LifemartPreviewRoute = LifemartPreviewRouteImport.update({
            id: '/lifemart/preview',path: '/lifemart/preview',getParentRoute: () => rootRouteImport
          })
const LifemartStackRoute = LifemartStackRouteImport.update({
            id: '/lifemart/stack',path: '/lifemart/stack',getParentRoute: () => rootRouteImport
          })
const LifemartStackInviteRoute = LifemartStackInviteRouteImport.update({
            id: '/lifemart/stack-invite',path: '/lifemart/stack-invite',getParentRoute: () => rootRouteImport
          })
const LifemartStackOfferRoute = LifemartStackOfferRouteImport.update({
            id: '/lifemart/stack-offer',path: '/lifemart/stack-offer',getParentRoute: () => rootRouteImport
          })
const LifemartSurveyRoute = LifemartSurveyRouteImport.update({
            id: '/lifemart/survey',path: '/lifemart/survey',getParentRoute: () => rootRouteImport
          })
const LpAgentRoute = LpAgentRouteImport.update({
            id: '/lp/agent',path: '/lp/agent',getParentRoute: () => rootRouteImport
          })
const LpOrganizationsRoute = LpOrganizationsRouteImport.update({
            id: '/lp/organizations',path: '/lp/organizations',getParentRoute: () => rootRouteImport
          })
const LpRubenRoute = LpRubenRouteImport.update({
            id: '/lp/ruben',path: '/lp/ruben',getParentRoute: () => rootRouteImport
          })
const MemberFollowupTokenRoute = MemberFollowupTokenRouteImport.update({
            id: '/member-followup/$token',path: '/member-followup/$token',getParentRoute: () => rootRouteImport
          })
const MortgageRatesIndexRoute = MortgageRatesIndexRouteImport.update({
            id: '/mortgage-rates/',path: '/mortgage-rates/',getParentRoute: () => rootRouteImport
          })
const MortgageRatesStateRoute = MortgageRatesStateRouteImport.update({
            id: '/mortgage-rates/$state',path: '/mortgage-rates/$state',getParentRoute: () => rootRouteImport
          })
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
            id: '/onboarding/',path: '/onboarding/',getParentRoute: () => rootRouteImport
          })
const OnboardingCreditMatchRoute = OnboardingCreditMatchRouteImport.update({
            id: '/onboarding/credit-match',path: '/onboarding/credit-match',getParentRoute: () => rootRouteImport
          })
const PSlugRoute = PSlugRouteImport.update({
            id: '/p/$slug',path: '/p/$slug',getParentRoute: () => rootRouteImport
          })
const PartnerSlugRoute = PartnerSlugRouteImport.update({
            id: '/partner/$slug',path: '/partner/$slug',getParentRoute: () => rootRouteImport
          })
const PartnersIndexRoute = PartnersIndexRouteImport.update({
            id: '/partners/',path: '/partners/',getParentRoute: () => rootRouteImport
          })
const PartnersChenoaFundRoute = PartnersChenoaFundRouteImport.update({
            id: '/partners/chenoa-fund',path: '/partners/chenoa-fund',getParentRoute: () => rootRouteImport
          })
const PartnersNacaRoute = PartnersNacaRouteImport.update({
            id: '/partners/naca',path: '/partners/naca',getParentRoute: () => rootRouteImport
          })
const PartnersNeighborworksRoute = PartnersNeighborworksRouteImport.update({
            id: '/partners/neighborworks',path: '/partners/neighborworks',getParentRoute: () => rootRouteImport
          })
const PartnersOperationHopeRoute = PartnersOperationHopeRouteImport.update({
            id: '/partners/operation-hope',path: '/partners/operation-hope',getParentRoute: () => rootRouteImport
          })
const PartnersUnidosUsRoute = PartnersUnidosUsRouteImport.update({
            id: '/partners/unidos-us',path: '/partners/unidos-us',getParentRoute: () => rootRouteImport
          })
const PartnersUrbanLeagueRoute = PartnersUrbanLeagueRouteImport.update({
            id: '/partners/urban-league',path: '/partners/urban-league',getParentRoute: () => rootRouteImport
          })
const PreviewHomieLifemartRoute = PreviewHomieLifemartRouteImport.update({
            id: '/preview/homie-lifemart',path: '/preview/homie-lifemart',getParentRoute: () => rootRouteImport
          })
const PreviewLarkStyleRoute = PreviewLarkStyleRouteImport.update({
            id: '/preview/lark-style',path: '/preview/lark-style',getParentRoute: () => rootRouteImport
          })
const ProfileCompleteRoute = ProfileCompleteRouteImport.update({
            id: '/profile/complete',path: '/profile/complete',getParentRoute: () => rootRouteImport
          })
const StackCheckTokenRoute = StackCheckTokenRouteImport.update({
            id: '/stack-check/$token',path: '/stack-check/$token',getParentRoute: () => rootRouteImport
          })
const StackIndexRoute = StackIndexRouteImport.update({
            id: '/stack/',path: '/stack/',getParentRoute: () => rootRouteImport
          })
const StackGuideRoute = StackGuideRouteImport.update({
            id: '/stack/guide',path: '/stack/guide',getParentRoute: () => rootRouteImport
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => rootRouteImport
          })
const ToolsAssistanceFundingAvailabilityRoute = ToolsAssistanceFundingAvailabilityRouteImport.update({
            id: '/tools/assistance-funding-availability',path: '/tools/assistance-funding-availability',getParentRoute: () => rootRouteImport
          })
const ToolsAvoidForeclosureRoute = ToolsAvoidForeclosureRouteImport.update({
            id: '/tools/avoid-foreclosure',path: '/tools/avoid-foreclosure',getParentRoute: () => rootRouteImport
          })
const ToolsBuyBeforeSellingRoute = ToolsBuyBeforeSellingRouteImport.update({
            id: '/tools/buy-before-selling',path: '/tools/buy-before-selling',getParentRoute: () => rootRouteImport
          })
const ToolsCashToCloseRoute = ToolsCashToCloseRouteImport.update({
            id: '/tools/cash-to-close',path: '/tools/cash-to-close',getParentRoute: () => rootRouteImport
          })
const ToolsClosingDisclosureReviewRoute = ToolsClosingDisclosureReviewRouteImport.update({
            id: '/tools/closing-disclosure-review',path: '/tools/closing-disclosure-review',getParentRoute: () => rootRouteImport
          })
const ToolsCombiningAssistanceProgramsRoute = ToolsCombiningAssistanceProgramsRouteImport.update({
            id: '/tools/combining-assistance-programs',path: '/tools/combining-assistance-programs',getParentRoute: () => rootRouteImport
          })
const ToolsCompareLenderQuotesRoute = ToolsCompareLenderQuotesRouteImport.update({
            id: '/tools/compare-lender-quotes',path: '/tools/compare-lender-quotes',getParentRoute: () => rootRouteImport
          })
const ToolsCompareLoanEstimatesRoute = ToolsCompareLoanEstimatesRouteImport.update({
            id: '/tools/compare-loan-estimates',path: '/tools/compare-loan-estimates',getParentRoute: () => rootRouteImport
          })
const ToolsDownPaymentAssistanceEstimateRoute = ToolsDownPaymentAssistanceEstimateRouteImport.update({
            id: '/tools/down-payment-assistance-estimate',path: '/tools/down-payment-assistance-estimate',getParentRoute: () => rootRouteImport
          })
const ToolsDpaHiddenStringsRoute = ToolsDpaHiddenStringsRouteImport.update({
            id: '/tools/dpa-hidden-strings',path: '/tools/dpa-hidden-strings',getParentRoute: () => rootRouteImport
          })
const ToolsDpaSellOrRefinanceRoute = ToolsDpaSellOrRefinanceRouteImport.update({
            id: '/tools/dpa-sell-or-refinance',path: '/tools/dpa-sell-or-refinance',getParentRoute: () => rootRouteImport
          })
const ToolsFindHousingCounselorRoute = ToolsFindHousingCounselorRouteImport.update({
            id: '/tools/find-housing-counselor',path: '/tools/find-housing-counselor',getParentRoute: () => rootRouteImport
          })
const ToolsFirstResponderHomeBuyingRoute = ToolsFirstResponderHomeBuyingRouteImport.update({
            id: '/tools/first-responder-home-buying',path: '/tools/first-responder-home-buying',getParentRoute: () => rootRouteImport
          })
const ToolsFreeHomebuyingReadinessToolsRoute = ToolsFreeHomebuyingReadinessToolsRouteImport.update({
            id: '/tools/free-homebuying-readiness-tools',path: '/tools/free-homebuying-readiness-tools',getParentRoute: () => rootRouteImport
          })
const ToolsHighIncomeDownPaymentHelpRoute = ToolsHighIncomeDownPaymentHelpRouteImport.update({
            id: '/tools/high-income-down-payment-help',path: '/tools/high-income-down-payment-help',getParentRoute: () => rootRouteImport
          })
const ToolsHomeBuyingTimelineRoute = ToolsHomeBuyingTimelineRouteImport.update({
            id: '/tools/home-buying-timeline',path: '/tools/home-buying-timeline',getParentRoute: () => rootRouteImport
          })
const ToolsHomebuyerReadinessScoreRoute = ToolsHomebuyerReadinessScoreRouteImport.update({
            id: '/tools/homebuyer-readiness-score',path: '/tools/homebuyer-readiness-score',getParentRoute: () => rootRouteImport
          })
const ToolsInheritedHomeMortgageRoute = ToolsInheritedHomeMortgageRouteImport.update({
            id: '/tools/inherited-home-mortgage',path: '/tools/inherited-home-mortgage',getParentRoute: () => rootRouteImport
          })
const ToolsLoanOfficerQuestionsRoute = ToolsLoanOfficerQuestionsRouteImport.update({
            id: '/tools/loan-officer-questions',path: '/tools/loan-officer-questions',getParentRoute: () => rootRouteImport
          })
const ToolsLowIncomeFirstTimeBuyerGrantsRoute = ToolsLowIncomeFirstTimeBuyerGrantsRouteImport.update({
            id: '/tools/low-income-first-time-buyer-grants',path: '/tools/low-income-first-time-buyer-grants',getParentRoute: () => rootRouteImport
          })
const ToolsMortgagePreapprovalMeetingRoute = ToolsMortgagePreapprovalMeetingRouteImport.update({
            id: '/tools/mortgage-preapproval-meeting',path: '/tools/mortgage-preapproval-meeting',getParentRoute: () => rootRouteImport
          })
const ToolsMortgageReadyChecklistRoute = ToolsMortgageReadyChecklistRouteImport.update({
            id: '/tools/mortgage-ready-checklist',path: '/tools/mortgage-ready-checklist',getParentRoute: () => rootRouteImport
          })
const ToolsNonprofitMortgageHelpRoute = ToolsNonprofitMortgageHelpRouteImport.update({
            id: '/tools/nonprofit-mortgage-help',path: '/tools/nonprofit-mortgage-help',getParentRoute: () => rootRouteImport
          })
const ToolsRaiseCreditScoreBeforeMortgageRoute = ToolsRaiseCreditScoreBeforeMortgageRouteImport.update({
            id: '/tools/raise-credit-score-before-mortgage',path: '/tools/raise-credit-score-before-mortgage',getParentRoute: () => rootRouteImport
          })
const ToolsRealAffordabilityRoute = ToolsRealAffordabilityRouteImport.update({
            id: '/tools/real-affordability',path: '/tools/real-affordability',getParentRoute: () => rootRouteImport
          })
const ToolsRelocationTimingRoute = ToolsRelocationTimingRouteImport.update({
            id: '/tools/relocation-timing',path: '/tools/relocation-timing',getParentRoute: () => rootRouteImport
          })
const ToolsRepaymentTriggersRoute = ToolsRepaymentTriggersRouteImport.update({
            id: '/tools/repayment-triggers',path: '/tools/repayment-triggers',getParentRoute: () => rootRouteImport
          })
const ToolsRightTimeToBuyRoute = ToolsRightTimeToBuyRouteImport.update({
            id: '/tools/right-time-to-buy',path: '/tools/right-time-to-buy',getParentRoute: () => rootRouteImport
          })
const ToolsStudentLoanMortgageGuideRoute = ToolsStudentLoanMortgageGuideRouteImport.update({
            id: '/tools/student-loan-mortgage-guide',path: '/tools/student-loan-mortgage-guide',getParentRoute: () => rootRouteImport
          })
const ToolsWhatIsMyHomeWorthRoute = ToolsWhatIsMyHomeWorthRouteImport.update({
            id: '/tools/what-is-my-home-worth',path: '/tools/what-is-my-home-worth',getParentRoute: () => rootRouteImport
          })
const WebinarsIndexRoute = WebinarsIndexRouteImport.update({
            id: '/webinars/',path: '/webinars/',getParentRoute: () => rootRouteImport
          })
const WebinarsIdRoute = WebinarsIdRouteImport.update({
            id: '/webinars/$id',path: '/webinars/$id',getParentRoute: () => rootRouteImport
          })
const AdminBlogIndexRoute = AdminBlogIndexRouteImport.update({
            id: '/admin/blog/',path: '/admin/blog/',getParentRoute: () => rootRouteImport
          })
const AdminBlogIdRoute = AdminBlogIdRouteImport.update({
            id: '/admin/blog/$id',path: '/admin/blog/$id',getParentRoute: () => rootRouteImport
          })
const AdminBlogNewRoute = AdminBlogNewRouteImport.update({
            id: '/admin/blog/new',path: '/admin/blog/new',getParentRoute: () => rootRouteImport
          })
const ClosingCostsCityCityRoute = ClosingCostsCityCityRouteImport.update({
            id: '/closing-costs/city/$city',path: '/closing-costs/city/$city',getParentRoute: () => rootRouteImport
          })
const FirstTimeBuyerCityCityRoute = FirstTimeBuyerCityCityRouteImport.update({
            id: '/first-time-buyer/city/$city',path: '/first-time-buyer/city/$city',getParentRoute: () => rootRouteImport
          })
const GrantsCityCityRoute = GrantsCityCityRouteImport.update({
            id: '/grants/city/$city',path: '/grants/city/$city',getParentRoute: () => rootRouteImport
          })
const LearnSlugStepIndexRoute = LearnSlugStepIndexRouteImport.update({
            id: '/learn/$slug/$stepIndex',path: '/learn/$slug/$stepIndex',getParentRoute: () => rootRouteImport
          })
const LpHeroStackIndexRoute = LpHeroStackIndexRouteImport.update({
            id: '/lp/hero-stack/',path: '/lp/hero-stack/',getParentRoute: () => rootRouteImport
          })
const LpHeroStackThankYouRoute = LpHeroStackThankYouRouteImport.update({
            id: '/lp/hero-stack/thank-you',path: '/lp/hero-stack/thank-you',getParentRoute: () => rootRouteImport
          })
const LpRubenHeroIndexRoute = LpRubenHeroIndexRouteImport.update({
            id: '/lp/ruben-hero/',path: '/lp/ruben-hero/',getParentRoute: () => rootRouteImport
          })
const LpRubenHeroResultsRoute = LpRubenHeroResultsRouteImport.update({
            id: '/lp/ruben-hero/results',path: '/lp/ruben-hero/results',getParentRoute: () => rootRouteImport
          })
const MortgageRatesCityCityRoute = MortgageRatesCityCityRouteImport.update({
            id: '/mortgage-rates/city/$city',path: '/mortgage-rates/city/$city',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AffordabilitySimulatorRoute: AffordabilitySimulatorRoute,AgentAuthRoute: AgentAuthRoute,AgentDashboardRoute: AgentDashboardRoute,AuthRoute: AuthRoute,CheckMyScoreRoute: CheckMyScoreRoute,ChecklistRoute: ChecklistRoute,CompanyDashboardRoute: CompanyDashboardRoute,ContactRoute: ContactRoute,ContestsRoute: ContestsRoute,CreditReadinessRoute: CreditReadinessRoute,DashboardRoute: DashboardRoute,DownPaymentPlannerRoute: DownPaymentPlannerRoute,EmployerDashboardRoute: EmployerDashboardRoute,EmployerOnboardingRoute: EmployerOnboardingRoute,EmployerReportRoute: EmployerReportRoute,ExpertAuthRoute: ExpertAuthRoute,ExpertDashboardRoute: ExpertDashboardRoute,ExpertQaRoute: ExpertQaRoute,FocusGroupRoute: FocusGroupRoute,ForOrganizationsRoute: ForOrganizationsRoute,FoundingMembersRoute: FoundingMembersRoute,FreeCreditScoreRoute: FreeCreditScoreRoute,GoalsRoute: GoalsRoute,GrantFinderRoute: GrantFinderRoute,HeroBenefitsEnrollRoute: HeroBenefitsEnrollRoute,HeroHomeSignupRoute: HeroHomeSignupRoute,HeroRewardsRoute: HeroRewardsRoute,HomeValueRoute: HomeValueRoute,HomebuyerChecklistRoute: HomebuyerChecklistRoute,HomebuyingSupportRoute: HomebuyingSupportRoute,HomeownerCheckupRoute: HomeownerCheckupRoute,HowWeMakeMoneyRoute: HowWeMakeMoneyRoute,InstallRoute: InstallRoute,LeaderboardRoute: LeaderboardRoute,LenderMatchRoute: LenderMatchRoute,MortgageCalculatorsRoute: MortgageCalculatorsRoute,MortgageGlossaryRoute: MortgageGlossaryRoute,MyPlanRoute: MyPlanRoute,NeighborhoodExplorerRoute: NeighborhoodExplorerRoute,NeighborhoodWatchlistRoute: NeighborhoodWatchlistRoute,OffersRoute: OffersRoute,OurPromiseRoute: OurPromiseRoute,PointsStoreRoute: PointsStoreRoute,PrestigeRoute: PrestigeRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,PulseRoute: PulseRoute,ReadinessCheckRoute: ReadinessCheckRoute,ReferYourEmployerRoute: ReferYourEmployerRoute,RefiOptimizerRoute: RefiOptimizerRoute,RelocationCalculatorRoute: RelocationCalculatorRoute,RentVsBuyRoute: RentVsBuyRoute,RequestAccessRoute: RequestAccessRoute,ResetPasswordRoute: ResetPasswordRoute,RewardsRoute: RewardsRoute,ShareProgressRoute: ShareProgressRoute,SponsorDeckRoute: SponsorDeckRoute,SuccessStoriesRoute: SuccessStoriesRoute,TermsAndConditionsRoute: TermsAndConditionsRoute,WellnessSurveyRoute: WellnessSurveyRoute,YourMatchRoute: YourMatchRoute,AdminAffiliatesRoute: AdminAffiliatesRoute,AdminAudiencekeyRoute: AdminAudiencekeyRoute,AdminContentAutomationsRoute: AdminContentAutomationsRoute,AdminContentFlywheelRoute: AdminContentFlywheelRoute,AdminEmailAuthRoute: AdminEmailAuthRoute,AdminEmployersRoute: AdminEmployersRoute,AdminFocusGroupRoute: AdminFocusGroupRoute,AdminFunnelRoute: AdminFunnelRoute,AdminGeckocheckRoute: AdminGeckocheckRoute,AdminGeckocheckMcpRoute: AdminGeckocheckMcpRoute,AdminGrantsRoute: AdminGrantsRoute,AdminLeadBriefRoute: AdminLeadBriefRoute,AdminLinkBuilderRoute: AdminLinkBuilderRoute,AdminMembersRoute: AdminMembersRoute,AdminOffersRoute: AdminOffersRoute,AdminPeoPartnersRoute: AdminPeoPartnersRoute,AdminPulseRoute: AdminPulseRoute,AdminReportingRoute: AdminReportingRoute,AdminSmsRoute: AdminSmsRoute,AdminWebinarsRoute: AdminWebinarsRoute,ApprovedLendersStateRoute: ApprovedLendersStateRoute,ArticlesSlugRoute: ArticlesSlugRoute,BlogSlugRoute: BlogSlugRoute,ClosingCostsStateRoute: ClosingCostsStateRoute,DecksYonkersRoute: DecksYonkersRoute,EmbedGeneratorRoute: EmbedGeneratorRoute,EmbedReadinessRoute: EmbedReadinessRoute,EmployersClaimRoute: EmployersClaimRoute,ExpertFollowupTokenRoute: ExpertFollowupTokenRoute,ExpertsIdRoute: ExpertsIdRoute,FirstTimeBuyerStateRoute: FirstTimeBuyerStateRoute,GrantsStateRoute: GrantsStateRoute,GuidesSlugRoute: GuidesSlugRoute,HomieChatRoute: HomieChatRoute,LearnRubenRoute: LearnRubenRoute,LifemartAccessRoute: LifemartAccessRoute,LifemartFreeCreditScoreRoute: LifemartFreeCreditScoreRoute,LifemartHookPreviewRoute: LifemartHookPreviewRoute,LifemartPreviewRoute: LifemartPreviewRoute,LifemartStackRoute: LifemartStackRoute,LifemartStackInviteRoute: LifemartStackInviteRoute,LifemartStackOfferRoute: LifemartStackOfferRoute,LifemartSurveyRoute: LifemartSurveyRoute,LpAgentRoute: LpAgentRoute,LpOrganizationsRoute: LpOrganizationsRoute,LpRubenRoute: LpRubenRoute,MemberFollowupTokenRoute: MemberFollowupTokenRoute,MortgageRatesStateRoute: MortgageRatesStateRoute,OnboardingCreditMatchRoute: OnboardingCreditMatchRoute,PSlugRoute: PSlugRoute,PartnerSlugRoute: PartnerSlugRoute,PartnersChenoaFundRoute: PartnersChenoaFundRoute,PartnersNacaRoute: PartnersNacaRoute,PartnersNeighborworksRoute: PartnersNeighborworksRoute,PartnersOperationHopeRoute: PartnersOperationHopeRoute,PartnersUnidosUsRoute: PartnersUnidosUsRoute,PartnersUrbanLeagueRoute: PartnersUrbanLeagueRoute,PreviewHomieLifemartRoute: PreviewHomieLifemartRoute,PreviewLarkStyleRoute: PreviewLarkStyleRoute,ProfileCompleteRoute: ProfileCompleteRoute,StackCheckTokenRoute: StackCheckTokenRoute,StackGuideRoute: StackGuideRoute,ToolsAssistanceFundingAvailabilityRoute: ToolsAssistanceFundingAvailabilityRoute,ToolsAvoidForeclosureRoute: ToolsAvoidForeclosureRoute,ToolsBuyBeforeSellingRoute: ToolsBuyBeforeSellingRoute,ToolsCashToCloseRoute: ToolsCashToCloseRoute,ToolsClosingDisclosureReviewRoute: ToolsClosingDisclosureReviewRoute,ToolsCombiningAssistanceProgramsRoute: ToolsCombiningAssistanceProgramsRoute,ToolsCompareLenderQuotesRoute: ToolsCompareLenderQuotesRoute,ToolsCompareLoanEstimatesRoute: ToolsCompareLoanEstimatesRoute,ToolsDownPaymentAssistanceEstimateRoute: ToolsDownPaymentAssistanceEstimateRoute,ToolsDpaHiddenStringsRoute: ToolsDpaHiddenStringsRoute,ToolsDpaSellOrRefinanceRoute: ToolsDpaSellOrRefinanceRoute,ToolsFindHousingCounselorRoute: ToolsFindHousingCounselorRoute,ToolsFirstResponderHomeBuyingRoute: ToolsFirstResponderHomeBuyingRoute,ToolsFreeHomebuyingReadinessToolsRoute: ToolsFreeHomebuyingReadinessToolsRoute,ToolsHighIncomeDownPaymentHelpRoute: ToolsHighIncomeDownPaymentHelpRoute,ToolsHomeBuyingTimelineRoute: ToolsHomeBuyingTimelineRoute,ToolsHomebuyerReadinessScoreRoute: ToolsHomebuyerReadinessScoreRoute,ToolsInheritedHomeMortgageRoute: ToolsInheritedHomeMortgageRoute,ToolsLoanOfficerQuestionsRoute: ToolsLoanOfficerQuestionsRoute,ToolsLowIncomeFirstTimeBuyerGrantsRoute: ToolsLowIncomeFirstTimeBuyerGrantsRoute,ToolsMortgagePreapprovalMeetingRoute: ToolsMortgagePreapprovalMeetingRoute,ToolsMortgageReadyChecklistRoute: ToolsMortgageReadyChecklistRoute,ToolsNonprofitMortgageHelpRoute: ToolsNonprofitMortgageHelpRoute,ToolsRaiseCreditScoreBeforeMortgageRoute: ToolsRaiseCreditScoreBeforeMortgageRoute,ToolsRealAffordabilityRoute: ToolsRealAffordabilityRoute,ToolsRelocationTimingRoute: ToolsRelocationTimingRoute,ToolsRepaymentTriggersRoute: ToolsRepaymentTriggersRoute,ToolsRightTimeToBuyRoute: ToolsRightTimeToBuyRoute,ToolsStudentLoanMortgageGuideRoute: ToolsStudentLoanMortgageGuideRoute,ToolsWhatIsMyHomeWorthRoute: ToolsWhatIsMyHomeWorthRoute,WebinarsIdRoute: WebinarsIdRoute,AdminIndexRoute: AdminIndexRoute,ApprovedLendersIndexRoute: ApprovedLendersIndexRoute,ArticlesIndexRoute: ArticlesIndexRoute,BlogIndexRoute: BlogIndexRoute,ClosingCostsIndexRoute: ClosingCostsIndexRoute,ExpertsIndexRoute: ExpertsIndexRoute,FirstTimeBuyerIndexRoute: FirstTimeBuyerIndexRoute,GrantsIndexRoute: GrantsIndexRoute,GuidesIndexRoute: GuidesIndexRoute,HomieIndexRoute: HomieIndexRoute,LearnIndexRoute: LearnIndexRoute,LifemartIndexRoute: LifemartIndexRoute,MortgageRatesIndexRoute: MortgageRatesIndexRoute,OnboardingIndexRoute: OnboardingIndexRoute,PartnersIndexRoute: PartnersIndexRoute,StackIndexRoute: StackIndexRoute,ToolsIndexRoute: ToolsIndexRoute,WebinarsIndexRoute: WebinarsIndexRoute,AdminBlogIdRoute: AdminBlogIdRoute,AdminBlogNewRoute: AdminBlogNewRoute,ClosingCostsCityCityRoute: ClosingCostsCityCityRoute,FirstTimeBuyerCityCityRoute: FirstTimeBuyerCityCityRoute,GrantsCityCityRoute: GrantsCityCityRoute,LearnSlugStepIndexRoute: LearnSlugStepIndexRoute,LpHeroStackThankYouRoute: LpHeroStackThankYouRoute,LpRubenHeroResultsRoute: LpRubenHeroResultsRoute,MortgageRatesCityCityRoute: MortgageRatesCityCityRoute,AdminBlogIndexRoute: AdminBlogIndexRoute,LpHeroStackIndexRoute: LpHeroStackIndexRoute,LpRubenHeroIndexRoute: LpRubenHeroIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)